/**
 *
 * @param phoneNumber
 * @returns True if number that starts with "+" and contains a mix of digits and spaces with at least 4 digits.
 */
const isValidPhoneNumber = phoneNumber => /^\+[\d-\s]+$/.test(phoneNumber) && (phoneNumber.match(/\d+/g)?.join('').length ?? 0) >= 4;

export { isValidPhoneNumber };
//# sourceMappingURL=isValidPhoneNumber.mjs.map
